import { isEmpty } from 'lodash';

import { fetch } from '@utils/utils';

export const editFile = ({ addError }) => async (fileId: string): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/ed/events/ms-office/edit/${fileId}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const result = await response.json();

    if (isEmpty(result)) {
      addError('Editace není podporována');
      return null;
    }

    return result;
  } catch (err) {
    addError(err);
    return null;
  }
};

export const saveFile = ({ addError }) => async (body: { fileId: string; eventId: string }): Promise<boolean> => {
  try {
    const response: any = await fetch('/metropolis/api/ed/events/ms-office/save', {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    const result = await response.json();

    return result;
  } catch (err) {
    addError(err);
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/components/form/Upload/_uploadActions.ts